exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".last-updated-container {\n  align-items: center;\n  color: #8f8f91;\n  display: flex;\n  white-space: nowrap;\n}\n.last-updated-container.is-compact {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports
